<template>
  <div class="table-container">
      <div class="vendors-subheader filters-row">
        <filter-table
          layout="text"
          @inputSearchFilter="inputSearchFilter">
        </filter-table>
        <!-- <ods-input-search
          size='hecto'
          outlined
          placeholder='Buscar'
          @input='tpvSearch'>
        </ods-input-search> -->
      <ventana-terminal
        @mostrarVentanaTerminal="mostrarVentanaTerminalTabla"
        :codcomercio="codcomercio"
        :desdescomercio="desdescomercio"
        :listadoTPV="comboTpv">
      </ventana-terminal>
      </div>
      <div v-if="tpv">
        <ods-table
        v-loading="loadingTable"
        :data="getlistTpvData"
        class="table-style ods-mt-6"
        highlight-current-row
        reserve-selection>
        <ods-table-column
        prop="codterm"
        label="CÓDIGO DE TERMINAL"
        min-width="100"
        sortable></ods-table-column>
        <ods-table-column
        prop="texto"
        label="TEXTO"
        min-width="150"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="descripsit"
        min-width="100"
        label="SITUACIÓN"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="usuario"
        label="USUARIO"
        min-width="120"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="fecalta.valueDate"
        label="FECHA DE ALTA"
        min-width="120"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="telefono"
        label="TELEFONO"
        min-width="120"
        sortable>
        </ods-table-column>
        <ods-table-column
          prop="object"
          label="ACCIONES"
          align="right"
          min-width="40">
          <template slot-scope="scope">
            <ods-row>
              <ods-actions-menu
                customClass="card-menu"
                icon="overflow-menu"
                color="#888A91"
                size="18"
                popoverPosition="bottom-end">
                  <ul class="menu">
                    <li class="menu__item">
                      <a href="#" @click.prevent="openModifyModal(scope.$index, scope.row)">
                        <ods-icon name="eye" color="#B6B6B6" size="24" style="vertical-align: middle" class="ods-mr-2"></ods-icon>
                        <span>Ver detalle</span>
                      </a>
                    </li>
                    <li class="menu__item">
                      <a href="#" @click.prevent="openDeleteModal(scope.$index, scope.row)" style="color: #DE2F2F">
                        <ods-icon name="delete" color="#DE2F2F" size="24" style="vertical-align: middle" class="ods-mr-2"></ods-icon>
                        <span>Eliminar terminal</span>
                      </a>
                    </li>
                  </ul>
              </ods-actions-menu>
            </ods-row>
          </template>
        </ods-table-column>
      </ods-table>
      <div class="footer">
        <paginator
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage">
        </paginator>
        <!-- <ods-pagination class="footer__page"
          :page-sizes = '[5, 10, 50, 100]'
          :page-size = itemsPerPage
          layout='prev, pager, next'
          :total='totalData'
          @size-change='handleSizeChange'
          @current-change='handleCurrentChange'
          style="text-align: right; margin-top: 20px">
        </ods-pagination> -->
      </div>
      </div>
      <div v-else style="text-align: center;">
            <ods-row>
              <img :src="require('@/assets/icons/pic_map.svg')">
            </ods-row>
            <ods-row>
              <span class="todas-las-rutas-de-e">Sin resultados de búsqueda</span>
            </ods-row>
      </div>
  <ventana-borrar-terminal
    @mostrarTerminal="mostrarTpvs"
    :codcomercio="codcomercio"
    :isVisible="dialogVisible"
    :rowDelete="rowSeleccionada"
    :toggleVisible="toggleDeleteTerminal"
    @closingDialog="dialogVisible = $event">
  </ventana-borrar-terminal>
  <ventana-modificar-terminal
    :codcomercio="codcomercio"
    :isVisible="dialogModificarVisible"
    :rowModify="rowSeleccionada"
    :toggleVisible="toggleModifyTerminal"
    @closingDialog="dialogModificarVisible = $event">
  </ventana-modificar-terminal>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import VentanaTerminal from '@/components/dialogs/VentanaTerminal'
import VentanaBorrarTerminal from '@/components/dialogs/VentanaBorrarTerminal'
import VentanaModificarTPV from '@/components/dialogs/VentanaModificarTPV'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  props: ['tpv', 'codcomercio', 'desdescomercio'],
  data () {
    return {
      searched: '',
      mostrarTpv: true,
      rowSeleccionada: '',
      dialogVisible: false,
      dialogModificarVisible: false,
      // listadoTpv: [],
      // newlistadoTpv: [],
      icon: 'overflow-menu',
      popoverPosition: 'left-end',
      mobilePopoverPosition: 'bottom-end',
      boundariesElement: '#root',
      myClass: 'myClass',
      actionMenuRow: false,
      // totalData: 0,
      // itemsPerPage: 10
      // Nuevos
      defaultParams: { codcom: this.codcomercio },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      comboTpv: []
    }
  },
  watch: {
    // data (newData, oldData) {
    //   this.newlistadoTpv = newData
    //   this.listadoTpv = newData
    //   this.totalData = newData.length
    // }
  },
  methods: {
    getData (params) {
      this.loadingTable = true
      // Listado de QR - Terminales QR
      this.$store.dispatch('listTpv', params)
        .then((res) => {
          this.getComboTPV()
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
          this.$emit('totalTPV', this.tableDataRendered ? this.tableDataRendered.length : 0)
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      if (this.tableData) {
        this.tableDataRendered = this.tableData.filter((res) => {
          return res.codterm.toLowerCase().includes(text.toLowerCase()) ||
            res.texto.toLowerCase().includes(text.toLowerCase()) ||
            res.descripsit.toLowerCase().includes(text.toLowerCase()) ||
            res.usuario.toLowerCase().includes(text.toLowerCase())
        })
      }
    },

    getComboTPV () {
      if (!this.getTpvList) {
        // Listado de Desplegable TPV
        this.$store.dispatch('listVisorTPVS', { codcom: this.codcomercio })
          .then((res) => {
            this.comboTpv = Array.isArray(res.registros) ? res.registros : [res.registros]
          })
      } else {
        this.comboTpv = this.getTpvList
      }
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    openDeleteModal (index, row) {
      this.rowSeleccionada = row
      this.toggleDeleteTerminal()
    },
    openModifyModal (index, row) {
      this.rowSeleccionada = row
      this.toggleModifyTerminal()
    },
    openModifyModalRow (index, row) {
      if (this.actionMenuRow === false) {
        this.rowSeleccionada = index
        this.toggleModifyTerminal()
        this.actionMenuRow = false
      }
      this.actionMenuRow = false
    },
    toggleDeleteTerminal () {
      if (this.dialogVisible) {
        this.dialogVisible = false
      } else {
        this.dialogVisible = true
      }
    },
    toggleModifyTerminal () {
      if (this.dialogModificarVisible) {
        this.dialogModificarVisible = false
      } else {
        this.dialogModificarVisible = true
      }
    },
    onShow () {
      this.actionMenuRow = true
    },
    // tpvSearch (text) {
    //   this.newlistadoTpv = this.listadoTpv.filter((res) => {
    //     return res.codterm.toLowerCase().includes(text.toLowerCase()) ||
    //       res.texto.toLowerCase().includes(text.toLowerCase()) ||
    //       res.descripsit.toLowerCase().includes(text.toLowerCase()) ||
    //       res.usuario.toLowerCase().includes(text.toLowerCase())
    //   })
    // },
    mostrarVentanaTerminalTabla (terminalParams) {
      this.tpv = terminalParams
    },
    mostrarTpvs (params) {
      this.tpv = params
    }
  },
  computed: {
    ...mapGetters([
      'getlistTpvData',
      'getTpvList'
    ])
  },
  mounted () {
    this.getInitialData()
    // this.listadoTpv = this.data
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
  },
  components: {
    'ventana-terminal': VentanaTerminal,
    'ventana-borrar-terminal': VentanaBorrarTerminal,
    'ventana-modificar-terminal': VentanaModificarTPV,
    FilterTable,
    Paginator
  }
}
</script>
<style lang="scss" scoped>
.table-container {
  background-color: $--color-white;
}

.table-content {
  padding: rem(10);
}

.table-style {
  width: 100%
}

.terminal-table {
  position: absolute; left: 15px;
  margin-right: 3%;
}

.input-search-table {
  margin: rem(22) 0 rem(22) 0;
  align-items: left;
  margin-left: 15px;
}

.todas-las-rutas-de-e {
    height: 24px;
    color: #6E767D;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
}
.myClass{
    width: 144px;
    height: 648px;
    border-radius: 0;
    padding: 0;
  }
  /deep/.ods-actions-menu {
    width: 144px;
    border-radius: 0;
    padding: 0px;
  }
  /deep/ .ods-icon-delete {
    color: red;
  }
  /deep/ .ods-table td {
    padding: 9px 0;
  }
  .pointer {
    cursor: pointer;
  }

  .vendors-subheader {
    display: flex;
    justify-content: space-between;
    // align-items: baseline;
}
</style>
